import { ResponsiveSankey } from "@nivo/sankey";
import { DATA_KEY_COLORS } from "constants/chartsColors.constant";

interface SankeyChartProps {
    title: string;
    data: { nodes: { id: string; nodeColor?: string }[]; links: { source: string; target: string; value: number }[] };
}

function SankeyChart({ title, data }: SankeyChartProps) {
    const validLinks = data.links.filter((l) => l.value > 0);
    const usedNodeIds = new Set(validLinks.flatMap((l) => [l.source, l.target]));
    const validNodes = data.nodes.filter((n) => usedNodeIds.has(n.id));

    if (validLinks.length === 0 || validNodes.length === 0) return null;

    const safeData = { nodes: validNodes, links: validLinks };

    return (
        <div>
            <p style={{ fontSize: "0.9rem", fontWeight: 600, marginBottom: "0.5rem", color: "#111827" }}>{title}</p>
            <div style={{ height: 280 }}>
                <ResponsiveSankey
                    data={safeData}
                    margin={{ top: 20, right: 130, bottom: 20, left: 80 }}
                    align="justify"
                    nodeOpacity={1}
                    nodeBorderWidth={0}
                    nodeBorderRadius={3}
                    linkOpacity={0.5}
                    colors={(node: any) => node.nodeColor ?? DATA_KEY_COLORS[node.id] ?? "#a5b4fc"}
                    enableLinkGradient
                    labelPosition="outside"
                    labelOrientation="horizontal"
                    labelPadding={24}
                    labelTextColor={{ from: "color", modifiers: [["darker", 1]] }}
                    isInteractive={false}
                />
            </div>
        </div>
    );
}

export default SankeyChart;
